import SetNewPasswordWrapper from './SetNewPasswordWrapper.component';
import withHelmet from 'src/hocs/withHelmet';
import { compose } from 'ramda';
import withProps from 'src/hocs/withProps';
import { t } from 'src/i18n';

const enhance = compose(
  withProps({ title: t('general.title.setNewPassword') }),
  withHelmet
);

export default enhance(SetNewPasswordWrapper);
